/**
 * Stable key for when to reset `localItems` from server-derived preview rows.
 * Must include any field that affects the main preview panel; otherwise `useEffect`
 * will not run and the UI keeps stale state (e.g. old PDF after replacing a file
 * when prompt/hint/`firmAuthoredContent` are unchanged).
 */

export type PreviewServerSyncRow = {
  id: string;
  prompt: string;
  hint: string | null;
  itemType: string;
  dependencyType: string | null;
  dependencyObject?: unknown;
  firmAuthoredContent?: unknown;
  isCustomStep?: boolean;
};

function documentDependencyFingerprint(
  row: PreviewServerSyncRow
): { uuid: string | null; retrieval_token: string | null } | null {
  if (row.dependencyType !== 'document' || row.dependencyObject == null) {
    return null;
  }
  if (typeof row.dependencyObject !== 'object') return null;
  const o = row.dependencyObject as Record<string, unknown>;
  const uuid = typeof o.uuid === 'string' ? o.uuid : null;
  const retrieval_token =
    typeof o.retrieval_token === 'string' ? o.retrieval_token : null;
  if (uuid == null && retrieval_token == null) return null;
  return { uuid, retrieval_token };
}

export function previewServerItemsSyncKey(
  activeStep: number,
  items: PreviewServerSyncRow[]
): string {
  return JSON.stringify({
    step: activeStep,
    rows: items.map((i) => ({
      id: i.id,
      prompt: i.prompt,
      hint: i.hint,
      itemType: i.itemType,
      dependencyType: i.dependencyType,
      documentDependency: documentDependencyFingerprint(i),
      firmAuthoredContent: i.firmAuthoredContent ?? null,
      isCustomStep: Boolean(i.isCustomStep),
    })),
  });
}
